/** 
 * @Description: 委托供应确认书审批表
 * @Author: hexy
 * @Date: 2023-03-09 11:05:05
 * @LastEditors: hexy
 * @LastEditTime: 2023-03-09 11:05:05
 * @FilePath: \ICPS\src\views\platform\ICPS\internetSales\supplyManagement\preparatoryCommission\PrintApproval.vue
**/

<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="1200px"
    :close-on-click-modal="false"
    class="print-approval-dialog"
    @close="handleClose"
  >
    <span slot="title" class="dialog-title">委托供应确认书审批表</span>
    <div id="printApprovalContent" class="print-content">
      <!-- 头部区域 -->
      <div class="approval-header">
        <div class="company-name">{{ displayCompanyName }}</div>
        <div class="title">委托供应确认书审批表</div>
        <div class="sub-info">
          <span class="sub-info-item">销售分部：{{ rowData.placeType || '--' }}</span>
          <span class="sub-info-item">{{ currentDate }}</span>
        </div>
      </div>

      <table class="main-table" cellspacing="0" cellpadding="0">
        <!-- 基本信息部分 (保持不变) -->
        <tr class="info-row">
          <td class="label-col">工程名称</td>
          <td class="value-col">{{ rowData.engineeringName || '--' }}</td>
          <td class="label-col">责任销售</td>
          <td class="value-col">{{ rowData.saller || rowData.createUserName || '--' }}</td>
        </tr>
        <tr class="info-row">
          <td class="label-col">拟签订合同单位</td>
          <td class="value-col">{{ rowData.businesName || rowData.companyName || '--' }}</td>
          <td class="label-col">委托确认方式</td>
          <td class="value-col">{{ rowData.delegationType || '--' }}</td>
        </tr>
        <tr class="info-row">
          <td class="label-col">首次供应时间</td>
          <td colspan="3" class="value-col">{{ formattedFirstSupplyTime }}</td>
        </tr>
        <tr class="info-row">
          <td class="label-col">截止审批日已供方量</td>
          <td class="value-col">{{ supplyQuantity }} m³</td>
          <td class="label-col">本次审批时限，累计方量</td>
          <td class="value-col">
            已审批{{ approvalsNumber }}次，
            本次申请供至{{ formattedLeaderDeadline }}且累计限量{{ leaderCommissionedQuantity }} m³
          </td>
        </tr>
        <!-- <tr class="info-row">
          <td class="label-col">核定单签订情况</td>
          <td class="value-col">{{ orderSignStatus }}</td>
          <td class="label-col">核定单效力</td>
          <td class="value-col">
            <div class="sign-status">
              <span class="checkbox-item">
                是否为委托书中约定的核定单，签字人签字。（是<input type="checkbox" :checked="isSignatureChecked" disabled  />否<input type="checkbox" :checked="!isSignatureChecked" disabled />）
              </span>
            </div>
          </td>
        </tr> -->
        <tr class="info-row">
          <td class="label-col">核定单签订情况</td>
          <td class="value-col">{{ orderSignStatus }}</td>
          <td class="label-col">核定单效力</td>
          <td class="value-col">
            <div class="sign-status-row">
              <span class="sign-text">是否为委托书中约定的核定单，签字人签字：（</span>
              <label class="sign-item">
                是<input type="checkbox" :checked="isSignatureChecked" disabled class="sign-checkbox" />
              </label>
              <label class="sign-item">
                否<input type="checkbox" :checked="!isSignatureChecked" disabled class="sign-checkbox" />
              </label>
              <span class="sign-text">）</span>
            </div>
          </td>
        </tr>
        <tr class="opinion-row">
          <td class="opinion-label-col">需办理委托原因与合同推进情况与预计签订时间简述</td>
          <td colspan="3" class="opinion-value-col">{{ rowData.argument || '--' }}</td>
        </tr>
        <tr class="opinion-row">
          <td class="opinion-label-col">销售分部负责人意见</td>
          <td colspan="3" class="opinion-value-col">{{ getApprovalOpinion('销售分部负责人') }}</td>
        </tr>
        <tr class="opinion-row">
          <td class="opinion-label-col">销售片区负责人意见</td>
          <td colspan="3" class="opinion-value-col">{{ getApprovalOpinion('销售片区负责人') }}</td>
        </tr>
        <tr class="opinion-row">
          <td class="opinion-label-col">销售部意见</td>
          <td colspan="3" class="opinion-value-col">{{ getApprovalOpinion('销售部') }}</td>
        </tr>
        <tr class="opinion-row">
          <td class="opinion-label-col">法务部意见</td>
          <td colspan="3" class="opinion-value-col">{{ getApprovalOpinion('法务部') }}</td>
        </tr>
        <tr class="opinion-row">
          <td class="opinion-label-col">销售分管领导意见</td>
          <td colspan="3" class="opinion-value-col">{{ getApprovalOpinion('销售分管领导') }}</td>
        </tr>
        <tr class="opinion-row">
          <td class="opinion-label-col">总经理意见</td>
          <td colspan="3" class="opinion-value-col">{{ getApprovalOpinion('总经理') }}</td>
        </tr>
      </table>

      <div class="footer-note">
        注：1.审批原件交法务部审核后移交销售部存档。作为工程交接、生产供应指令核依据。<br />
        2.供应指令需在委托有效期内且有明确销量限量
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="dialogVisible = false">关 闭</el-button>
      <el-button class="bottom_all" style="margin-left: 24px" @click="doPrint">打 印</el-button>
    </span>
  </el-dialog>
</template>

<script>
import printJS from 'print-js'
import { getNodeList } from "@/api/task/flows";

export default {
  name: 'PrintApprovalDialog',
  props: {
    visible: { type: Boolean, default: false },
    rowData: { type: Object, default: () => ({}) },
    companyName: { type: String, default: '' }
  },
  data() {
    return {
      // 存储原始节点列表，用于模糊匹配
      approvalNodeList: []
    };
  },
  computed: {
    dialogVisible: {
      get() { return this.visible; },
      set(val) { this.$emit('update:visible', val); }
    },
    displayCompanyName() {
      return this.companyName || this.rowData.businessName || '四川华西综合混凝土工程有限公司';
    },
    currentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    formattedFirstSupplyTime() {
      return this.formatDate(this.rowData.firstSupplyTime);
    },
    supplyQuantity() {
      const val = this.rowData.supplyQuantity;
      return val !== undefined && val !== null ? val : 0;
    },
    approvalsNumber() {
      const num = this.rowData.approvalsNumber;
      return (num !== undefined && num !== null) ? num : 1;
    },
    formattedLeaderDeadline() {
      return this.formatDate(this.rowData.leaderDeadlineDate);
    },
    leaderCommissionedQuantity() {
      const val = this.rowData.leaderCommissionedQuantity;
      return (val !== undefined && val !== null) ? val : '--';
    },
    orderSignStatus() {
      const signedDate = this.formatDate(this.rowData.settleCurrentDueTime) || '--';
      const signedQty = (this.rowData.settleCumulativeValue !== undefined && this.rowData.settleCumulativeValue !== null)
        ? this.rowData.settleCumulativeValue : '--';
      const unsignedQty = (this.rowData.settleNotThroughValue !== undefined && this.rowData.settleNotThroughValue !== null)
        ? this.rowData.settleNotThroughValue : '--';
      return `核定单已签订至 ${signedDate}，${signedQty} m³，已供应但未签订核定单 ${unsignedQty} m³`;
    },
    isSignatureChecked() {
      return this.rowData.whertherSignature === 1;
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.getNode();
        });
      }
    },
  },
  methods: {
    handleClose() { 
      this.$emit('update:visible', false); 
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      if (typeof dateStr === 'string' && dateStr.includes('-')) {
        const parts = dateStr.split('-');
        if (parts.length === 3) return `${parts[0]}年${parts[1]}月${parts[2]}日`;
      }
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    doPrint() {
      printJS({
        printable: 'printApprovalContent',
        type: 'html',
        maxWidth: 'auto',
        targetStyles: ['*'],
        style: `
          @media print {
            @page { size: A4; margin: 0; }
            body { margin: 0; padding: 0; -webkit-print-color-adjust: exact; }
            #printApprovalContent { 
              width: 100%; 
              max-width: 210mm; 
              margin: 0 auto; 
              padding: 10mm 10mm; 
            }
          }
        `
      });
    },
    

    getApprovalOpinion(labelTitle) {
      return this.approvalNodeList.find(item => item.nodeName.includes(labelTitle))?.approvalOptions || "";
    },

    // 流程接口
    getNode(){
      if (!this.rowData.processManagerId || !this.rowData.processTaskId || !this.rowData.processVersionId) {
        console.warn('PrintApproval: 缺少流程节点查询所需的参数', this.rowData);
        return;
      }
      let params = {
        processManagerId: this.rowData.processManagerId,
        processTaskId: this.rowData.processTaskId,
        processVersionId: this.rowData.processVersionId
      }
      getNodeList(params).then(res => {
        if (res.code === 1001) {
          // 直接存储处理后的列表，供 getApprovalOpinion 遍历
          this.approvalNodeList = res.data.map(item => ({
            nodeName:  item.nodeName.replace(/\s/g, '') ,
            // nodeName: item.nodeName,
            approvalOptions: item.instanceLogsList[0].approvalOptions || ""
          }));
          console.log("PrintApproval: 审批节点数据已更新", this.approvalNodeList);
        } else {
          console.error('PrintApproval: 获取节点列表失败', res.codeMsg);
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
#printApprovalContent {
  width: 100%;
  max-width: 260mm;
  margin: 0 auto;
  background: white;
  padding: 10mm 10mm;
  font-family: 'SimSun', '宋体', 'Microsoft YaHei', Arial, sans-serif;
  color: #000;
  box-sizing: border-box;

  .approval-header {
    text-align: center;
    margin-bottom: 10px;
    .company-name {
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 2px;
      margin-bottom: 5px;
    }
    .title {
      font-size: 22px;
      font-weight: bold;
      padding: 5px 0;
      border-bottom: 2px solid #000;
      display: inline-block;
      margin-bottom: 5px;
    }
    .sub-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      font-size: 14px;
      margin-top: 5px;
      padding: 0 5px;
      .sub-info-item {
        white-space: nowrap;
      }
    }
  }

  table.main-table {
    width: 100%;
    border-collapse: collapse;
    border: 2px solid #000;
    table-layout: fixed; /* 固定布局，确保列宽可控 */
    
    td {
      border: 1px solid #000;
      padding: 8px 10px; /* 稍微增加内边距，让内容不那么拥挤 */
      vertical-align: middle;
      font-size: 14px; /* 【恢复】正常字体大小 */
      line-height: 1.6; 
    }

    /* 标签列：尽可能窄，但保证文字完整 */
    .label-col {
      width: 12%; 
      background-color: #f9fafc;
      text-align: center;
      font-weight: 600;
      color: #333;
      // white-space: nowrap;
      // overflow: hidden;
      text-overflow: ellipsis;
    }
    
    /* 内容列：自动填充 */
    .value-col {
      text-align: left;
      word-break: break-all;
    }

    /* 专门针对“核定单效力”右侧单元格的优化 */
    .sign-value-col {
      /* 不需要设置具体宽度，table-layout: fixed 下它会自动占据剩余空间 */
      /* 如果希望它更宽，可以减小 .label-col 的宽度 */
    }

    .opinion-label-col {
      width: 15%; 
      background-color: #f9fafc;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      vertical-align: top;
      padding: 8px 8px;
    }

    .opinion-value-col {
      min-height: 90px;
      height: 90px;     
      background-color: #fff;
      vertical-align: top;
      padding: 8px;
    }

    /* 【优化】核定单效力行的样式 */
    .sign-status-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap; /* 【关键】允许换行，避免内容被截断或溢出 */
      width: 100%;
      font-size: 14px; /* 【恢复】正常字体大小 */
      line-height: 1.8; /* 增加行高，换行后更美观 */
      
      .sign-text {
        white-space: nowrap; /* 括号和引导语不换行分离 */
      }
      
      .sign-item {
        display: inline-flex;
        align-items: center;
        margin: 0 6px; /* 适当间距 */
        white-space: nowrap;
        cursor: default;
        
        .sign-checkbox {
          margin-left: 3px;
          transform: scale(1.1); /* 【恢复】正常稍大一点的复选框，方便查看 */
          vertical-align: middle;
          cursor: default;
        }
      }
    }
  }

  .footer-note {
    font-size: 12px;
    color: #333;
    line-height: 1.4;
    margin-top: 10px;
    padding-top: 5px;
    border-top: 1px dashed #999;
  }
}

@media print {
  @page {
    size: A4;
    margin: 0;
  }
  body {
    margin: 0;
    padding: 0;
    background: white;
    -webkit-print-color-adjust: exact;
  }
  #printApprovalContent {
    width: 100%;
    max-width: 260mm;
    margin: 0 auto;
    padding: 10mm 10mm;
    box-shadow: none;
    border: none;
  }
  .opinion-value-col {
    min-height: 90px !important;
    height: 90px !important;
  }
  .info-row td {
    min-height: 30px;
  }
}

.print-approval-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
    max-height: 80vh;
    overflow-y: auto;
  }
}
</style>
